import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { getUserAvatarColor } from 'entities/Users/lib/getUserAvatarColor'
import { type IResponseTeam } from 'entities/Teams'

export class TeamRow extends RowBase<IResponseTeam> {
  constructor(origin: IResponseTeam) {
    super(origin)
    makeObservableRowBase(this)
  }

  get id() {
    return this.origin.id
  }

  get name() {
    return this.origin.name
  }

  get description() {
    return this.origin.description
  }

  get members() {
    return this.origin.members
  }

  get membersCount() {
    return this.members.length
  }

  get hasMembers() {
    return this.members.length > 0
  }

  get membersInfo() {
    return this.members.map((member) => ({
      fontSize: 10,
      image: member.photo_url,
      firstName: member.first_name,
      lastName: member.last_name,
      color: getUserAvatarColor(member.id),
    }))
  }

  get source() {
    return this.isIntegrationTeam ? 'HubSpot' : 'Salesmsg'
  }

  get isIntegrationTeam() {
    return this.origin.is_integration_team
  }

  get integrationTeam() {
    return this.origin.integration_team
  }
}
